export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  traitManager.addType('input-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const input = document.createElement('select');
      for (let i = 0; i < options.length; i++) {
        let name = options[i].name;
        let value = options[i].id;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }
      return input;
    },
    onEvent({ elInput, component }) {
      const attrs = { ...component.get('attributes') };
      const field = this.model.get('value') !== '' ? JSON.parse(this.model.get('value')) : '';
      if (field) {
        attrs['name'] = field.fieldName;
        attrs['placeholder'] = field.placeholder.en;
        if (component.is('input')) {
          attrs['type'] = field.type;
        }
        if (component.is('file')) {
          component.collection.forEach((comp) => {
            if (comp.getAttributes()['type'] === 'hidden') {
              const attrs = { ...comp.get('attributes') };
              attrs['name'] = field.fieldName;
              comp.set('attributes', attrs);
            }
          });
        }
        if (component.is('select')) {
          attrs['data-placeholder'] = `Choose a ${field.fieldTitle.en}`;
          delete attrs['multiple'];
        }
      } else {
        attrs['name'] = '';
        attrs['placeholder'] = '';
        if (component.is('input')) {
          attrs['type'] = '';
        }
        if (component.is('file')) {
          component.collection.forEach((comp) => {
            if (comp.getAttributes()['type'] === 'hidden') {
              const attrs = { ...comp.get('attributes') };
              attrs['name'] = '';
              comp.set('attributes', attrs);
            }
          });
        }
        if (component.is('select')) {
          attrs['data-placeholder'] = '';
        }
      }
      this.target.set('attributes', attrs);
    },

    onUpdate({ elInput, component }) {
      const opts = this.model.get('options') || [];
      if (opts !== undefined) {
        const selectedValue = opts.find((opt) => {
          if (opt.id !== '') {
            return JSON.parse(opt.id).fieldName === component.getAttributes()['name'];
          }
        });
        elInput.value = selectedValue ? selectedValue.id : '';
      }
    },
  });
}
